import { render, staticRenderFns } from "./NavbarV2.vue?vue&type=template&id=46390a5a"
import script from "./NavbarV2.vue?vue&type=script&lang=js"
export * from "./NavbarV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports